import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { trackUpdateAutoshipAddress, trackViewUpdateAutoshipAddressModal } from '@libs/analytics';
import { InfoModal } from '../../info-modal';
type ConfirmAutoshipDefaultAddressChangeModalProps = {
  isActive: boolean;
  isFraudValidationNeeded?: boolean;
  onClose: () => void;
  onKeepExistingAddress: () => void;
  onUpdateAddress: () => void;
  loading?: 'keep' | 'update';
};
const KEEP_BUTTON_TEXT = 'No, keep existing address';
const UPDATE_BUTTON_TEXT = 'Yes, update address';
const SITE_SECTION = 'my account | addresses';
export function ConfirmAutoshipDefaultAddressChangeModal(t0) {
  const $ = _c(24);
  const {
    isActive,
    isFraudValidationNeeded: t1,
    onClose,
    onKeepExistingAddress,
    onUpdateAddress,
    loading
  } = t0;
  const isFraudValidationNeeded = t1 === undefined ? false : t1;
  let t2;
  let t3;
  if ($[0] !== isActive) {
    t2 = () => {
      if (isActive) {
        trackViewUpdateAutoshipAddressModal(SITE_SECTION);
      }
    };
    t3 = [isActive];
    $[0] = isActive;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  let t4;
  if ($[3] !== onClose) {
    t4 = () => {
      trackUpdateAutoshipAddress({
        linkText: "close",
        siteSection: SITE_SECTION
      });
      onClose();
    };
    $[3] = onClose;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const handleClose = t4;
  const isKeepLoading = loading === "keep" && !isFraudValidationNeeded;
  const isUpdateLoading = loading === "update" || isFraudValidationNeeded && loading === "keep";
  const t5 = isFraudValidationNeeded ? "Update address" : "Update Autoship address";
  const t6 = isFraudValidationNeeded ? "Cancel" : KEEP_BUTTON_TEXT;
  let t7;
  if ($[5] !== onKeepExistingAddress) {
    t7 = () => {
      trackUpdateAutoshipAddress({
        linkText: KEEP_BUTTON_TEXT.toLowerCase(),
        siteSection: SITE_SECTION
      });
      onKeepExistingAddress();
    };
    $[5] = onKeepExistingAddress;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== isKeepLoading || $[8] !== t6 || $[9] !== t7) {
    t8 = {
      text: t6,
      onClick: t7,
      loading: isKeepLoading
    };
    $[7] = isKeepLoading;
    $[8] = t6;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const t9 = isFraudValidationNeeded ? "Save new address" : UPDATE_BUTTON_TEXT;
  let t10;
  if ($[11] !== onUpdateAddress) {
    t10 = () => {
      trackUpdateAutoshipAddress({
        linkText: UPDATE_BUTTON_TEXT.toLowerCase(),
        siteSection: SITE_SECTION
      });
      onUpdateAddress();
    };
    $[11] = onUpdateAddress;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== isUpdateLoading || $[14] !== t10 || $[15] !== t9) {
    t11 = {
      text: t9,
      onClick: t10,
      loading: isUpdateLoading
    };
    $[13] = isUpdateLoading;
    $[14] = t10;
    $[15] = t9;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  const t12 = isFraudValidationNeeded ? "Updating your address will save it as a new address in your account. Existing Autoship orders will continue using their current shipping address." : "Your previous default address is linked to one or more Autoship orders. Would you like to use your new default address for those Autoship orders?";
  let t13;
  if ($[17] !== handleClose || $[18] !== isActive || $[19] !== t11 || $[20] !== t12 || $[21] !== t5 || $[22] !== t8) {
    t13 = <InfoModal isActive={isActive} title={t5} onClose={handleClose} closeButtonTestId="update-autoship-modal-close-btn" footerTestId="update-autoship-modal-footer" secondaryAction={t8} primaryAction={t11} text={t12} />;
    $[17] = handleClose;
    $[18] = isActive;
    $[19] = t11;
    $[20] = t12;
    $[21] = t5;
    $[22] = t8;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  return t13;
}